import { render, staticRenderFns } from "./TailSelect.vue?vue&type=template&id=5c9d370c"
import script from "./TailSelect.vue?vue&type=script&lang=js"
export * from "./TailSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports